import React from "react";
import { Card, Row, Col, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import Chart from "react-apexcharts";


const AttendanceTrend = () => {

  const chartOptions = {
    chart: {
      type: "bar",
      height: 320,
      stacked: false,
      toolbar: { show: false }
    },

    colors: ["#ff6b1a", "#0f4c5c", "#f5b400"],

    plotOptions: {
      bar: {
        columnWidth: "35%",
        borderRadius: 3
      }
    },

    dataLabels: { enabled: false },

    stroke: { width: 0 },

    xaxis: {
      categories: ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"]
    },

    tooltip: {
      theme: "light"
    },

    legend: { show: false }
  };

  const chartSeries = [
    {
      name: "Present",
      data: [600,280,280,700,380,580,580]
    },
    {
      name: "Late",
      data: [40,90,40,40,90,90,90]
    },
    {
      name: "Absent",
      data: [80,40,120,80,120,40,120]
    }
  ];

  return (
    <Col className="d-flex mt-3">
      <Card className="flex-fill">
        <Card.Body className="pb-0">

          {/* Header */}

          <div className="border rounded border-start border-start-primary d-flex align-items-center justify-content-between p-2 flex-wrap mb-3">

            <h5 className="mb-0 fw-semibold">
              Attendance Trend
            </h5>

            <Dropdown>
              <Dropdown.Toggle className="btn btn-light border d-flex align-items-center no-arrow">
                <FiCalendar className="me-1"/>
                Weekly
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Monthly</Dropdown.Item>
                <Dropdown.Item>Weekly</Dropdown.Item>
                <Dropdown.Item>Today</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>

          {/* Top Stats */}

          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">

            <div className="d-flex align-items-center flex-wrap gap-3">

              <div className="pe-3 border-end">
                <h4 className="mb-0">
                  82 <span className="text-muted fs-14 ms-2">On-Time</span>
                </h4>
              </div>

              <div className="pe-3 border-end">
                <h4 className="mb-0">
                  11 <span className="text-muted fs-14 ms-2">Late</span>
                </h4>
              </div>

              <div>
                <h4 className="mb-0">
                  6 <span className="text-muted fs-14 ms-2">Absent</span>
                </h4>
              </div>

            </div>

            {/* Legend */}

            <div className="d-flex gap-3">

              <p className="mb-0">
                <span className="legend-box present"></span> Present
              </p>

              <p className="mb-0">
                <span className="legend-box late"></span> Late
              </p>

              <p className="mb-0">
                <span className="legend-box absent"></span> Absent
              </p>

            </div>

          </div>

          {/* Chart + Side Stats */}

          <div className="d-sm-flex">

            <div className="flex-grow-1">

              <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={300}
              />

            </div>

            <div className="attendance-side">

              <div className="attendance-box">
                <p>Max Working Hours</p>
                <h3>8.4 hrs</h3>
              </div>

              <div className="attendance-box">
                <p>Missed Punches</p>
                <h3>12</h3>
              </div>

              <div className="attendance-box">
                <p>Weekly Avg</p>
                <h3>97.2%</h3>
              </div>

            </div>

          </div>

        </Card.Body>
      </Card>
      <style>

          {


`

.border-start-primary{
border-left:3px solid #ff6b1a !important;
}

.legend-box{
width:12px;
height:12px;
display:inline-block;
border-radius:3px;
margin-right:6px;
}

.present{background:#ff6b1a;}
.late{background:#0f4c5c;}
.absent{background:#f5b400;}

.attendance-side{
width:180px;
margin-left:15px;
}

.attendance-box{
border:1px solid #e5e5e5;
border-radius:8px;
padding:15px;
text-align:center;
margin-bottom:15px;
}

.attendance-box p{
margin-bottom:5px;
color:#6c757d;
}

.no-arrow::after{
display:none!important;
}

@media(max-width:768px){

.attendance-side{
width:100%;
margin-left:0;
margin-top:20px;
}

}

`
          }
      </style>
    </Col>
  );
};

export default AttendanceTrend;